import React from 'react';
import MessageIdentityAvatar from './MessageIdentityAvatar.jsx';
import { resolveAssistantTurnPresentation } from "./assistantTurnPresentation.jsx";

/** One presentation owner for a round; activities are not messages. */
export default function AssistantTurn({ item, assistantName, renderMessageAvatar, renderItemNode, themeTokens }) {
  const { identity, sections } = resolveAssistantTurnPresentation(item.items ?? []);
  return (
    <section className="flare-assistant-turn" data-assistant-turn-id={item.id} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <MessageIdentityAvatar
        assistantName={assistantName}
        messageIdentityKey={identity}
        renderMessageAvatar={renderMessageAvatar}
        role="assistant"
        themeTokens={themeTokens}
      />
      {sections.map(({ entry, section, conclusionLabel }) => (
        <div className={`flare-assistant-turn-${section}`} key={entry.id}>
          {conclusionLabel ? (
            <section className="flare-execution-conclusion" aria-label={conclusionLabel}>
              <h3>{conclusionLabel}</h3>
              {renderItemNode(entry)}
            </section>
          ) : renderItemNode(entry)}
        </div>
      ))}
    </section>
  );
}
